<ng-template #profileMenu let-toggleDropdown="toggleDropdown" let-dropdownOpened="dropdownOpened">
  <rt-button
    [dropdown]="true"
    [dropdownIconDark]="true"
    [noUnderline]="true"
    (click)="toggleDropdown(true)"
    variant="plain no-padding"
  >
    <div *ngIf="profile" layout layout-align-items-center>
      <rt-avatar
        [type]="profile.avatarThumbUrl ? 'image' : 'initials'"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="profile.avatarThumbUrl"
        [fullName]="userName"
        [isColorized]="true"
        margin-right-small-x
      ></rt-avatar>
      <span class="user-name" text-semi-medium text-color> {{ userName }} </span>
    </div>
  </rt-button>
</ng-template>

<ng-template #profileMenuOption let-option="option">
  <div class="profile-menu-item">
    <rt-icon [name]="option.icon" margin-right-small></rt-icon>
    <span text-semi-medium> {{ option.label }} </span>
  </div>
</ng-template>

<ng-template #loggedContext>
  <nav margin-medium>
    <rt-tabs class="nav-tabs">
      <rt-tab [routerLinkActiveOptions]="{ exact: true }" routerLink="/" routerLinkActive="current">
        <a>
          {{ 'rtr.homepage.menu.jobs' | translate }}
        </a>
      </rt-tab>
      <rt-tab
        [routerLinkActiveOptions]="{ exact: true }"
        routerLink="/referrals"
        routerLinkActive="current"
      >
        <a>
          {{ 'rtr.homepage.menu.referrals' | translate }}
        </a>
      </rt-tab>
      <rt-tab
        [routerLinkActiveOptions]="{ exact: true }"
        routerLink="/how-it-works"
        routerLinkActive="current"
      >
        <a>
          {{ 'rtr.homepage.menu.how_it_works' | translate }}
        </a>
      </rt-tab>
    </rt-tabs>
  </nav>
  <rt-button (click)="toggleSidebar()" variant="only-icon small-xx no-padding" class="menu-trigger">
    <rt-icon [name]="sidebarOpen ? 'close' : 'menu'" size="large"></rt-icon>
  </rt-button>
  <rt-select
    class="profile-menu"
    [hasSearch]="false"
    [closeOnSelect]="true"
    [includeEmptyOption]="false"
    [minDropdownWidth]="150"
    [triggerTemplate]="profileMenu"
    [optionTemplate]="profileMenuOption"
    [options]="profileDropdownOptions"
    [dark]="true"
    [radiusDefault]="true"
    (valueChange)="onSelect($any($event))"
  >
  </rt-select>
</ng-template>

<ng-template #notLoggedContext>
  <ng-container *ngIf="sigInButtonActive; else signInTpl">
    <rtr-sign-in-button class="sign-in-button"></rtr-sign-in-button>
  </ng-container>

  <ng-template #signInTpl>
    <rtr-sign-up-button class="sign-up-button"></rtr-sign-up-button>
  </ng-template>
</ng-template>

<div class="header" layout layout-align-items-center layout-space-between>
  <rtr-header-logo
    *ngIf="program"
    [logoUrl]="program.logoUrl"
    [companyName]="program.companyName"
  ></rtr-header-logo>
  <ng-container
    *ngTemplateOutlet="
      headerContext === HeaderMenuContext.Logged ? loggedContext : notLoggedContext
    "
  ></ng-container>
</div>
<rt-divider></rt-divider>
